export default "__VITE_ASSET__C9niEfCE__"